// extracted by mini-css-extract-plugin
export default {"icon-wrapper":"Breadcrumbs_icon-wrapper__aefOw"};